<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-else>
      <CCardHeader>
        <div style="margin: auto" class="flex">
          <DatePicker
            v-model="value1"
            type="date"
            range
            placeholder="Select date range"
            style="float: left"
          ></DatePicker>

          <CCol sm="2" v-if="tokens.length > 0">
            <CSelect
              placeholder="select Token(optional)"
              :options="tokens"
              v-model="selecetedToken"
            />
          </CCol>
          <CButton
            color="success"
            style="margin-left: 15px"
            v-if="tokens.length > 0"
            @click="getByToken()"
            >Get by Token</CButton
          >
        </div>
        <JsonCSV
          v-if="tbl1"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
        <JsonCSV
          v-if="tbl2"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData2"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
      </CCardHeader>

      <CCardBody>
        <CDataTable
          v-if="tbl1"
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        </CDataTable>
        <CDataTable
          v-if="tbl2"
          :items="tableData2"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    JsonCSV,
    DatePicker,
  },
  props: {
    name: {
      type: String,
      default: "snake",
    },
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
      tbl1: true,
      tbl2: false,
      Spinner: true,
      tableData: [],
      userdata: [],
      tableData2: [],
      tokens: [],
      selecetedToken: "",
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        // {
        //   label: "Name",
        //   key: "name",
        //   sortable: true,
        // },
        {
          label: "Email",
          key: "email",
          sortable: true,
        },

        {
          label: "GamePoints",
          key: "points",
          sortable: true,
        },
        {
          label: "Earning Rage",
          key: "rage",
          sortable: true,
        },
        {
          label: "promo Applied",
          key: "promoApplied",
          sortable: true,
        },
        {
          label: "promo Type",
          key: "promoType",
          sortable: true,
        },
        {
          label: "Token Name",
          key: "tokenName",
          sortable: true,
        },

        // {
        //   label: "Country",
        //   key: "country",
        //   sortable: true,
        // },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      this.tableData2 = [];
      this.tbl1 = false;
      this.tbl2 = true;
      db.collection(`HTMLGamesPointsEntry`)
        .where("gameName", "==", this.name)
        .where("created", ">=", v1)
        .where("created", "<=", v2)
        .get()
        .then((snapshot) => {
          this.tableData2 = [];
          snapshot.forEach((doc) => {
            // let emaildata = this.userdata.filter((a) => {
            //   return a.email == doc.data().email;
            if (!this.tokens.includes(doc.data().tokenName)) {
              this.tokens.push(doc.data().tokenName);
            }
            // if (this.tokens.length > 0) {
            //   this.selecetedToken = this.tokens[0];
            // }
            // });
            this.Spinner = false;
            let backenddate = moment(doc.data().created.seconds * 1000).format(
              "DD-MMM-YYYY"
            );
            // if (backenddate >= v1 && backenddate <= v2) {
            this.tableData2.push({
              // Id: doc.id,
              //   name: emaildata[0].name,
              date: backenddate,
              email: doc.data().email,
              // date: doc.data().date,
              points: doc.data().points ? doc.data().points : 0,
              rage: doc.data().rage ? doc.data().rage.toFixed(2) : 0,
              promoType: doc.data().promoType ? doc.data().promoType : null,
              promoApplied: doc.data().promoApplied
                ? doc.data().promoApplied
                : false,
              tokenName: doc.data().tokenName,

              //   country: emaildata[0].country,
            });
            // }
          });
        });

      // console.log(this.tokens);
    },
    name() {
      this.getmessage();
    },
  },
  methods: {
    refresh() {
      window.location.reload();
      // this.tbl1=true;
      //  this.tbl2=false;
    },
    getmessage() {
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      // console.log(`${this.name} getting points for this game}`);
      this.tableData = [];
      db.collection(`HTMLGamesPointsEntry`)
        .where("gameName", "==", this.name)
        .where("created", ">=", startOfToday)
        .where("created", "<=", endOfToday)
        // .orderBy("date", "desc")
        // .limit(100)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            this.tbl1 = true;
            this.tbl2 = false;
            snapshot.forEach((doc) => {
              if (!this.tokens.includes(doc.data().tokenName)) {
                this.tokens.push(doc.data().tokenName);
              }

              // if (this.tokens.length > 0) {
              //   this.selecetedToken = this.tokens[0];
              // }
              // console.log("this.userdata", doc.id);
              // let emaildata = this.userdata.filter((a) => {
              //   return a.email == doc.data().email;
              // });
              // console.log("emaildata[0]",emaildata[0].name)
              this.Spinner = false;
              let backenddate = moment(
                doc.data().created.seconds * 1000
              ).format("DD-MMM-YYYY");

              this.tableData.push({
                Id: doc.id,
                // name: emaildata[0].name,
                email: doc.data().email,
                date: doc.data().date,
                points: doc.data().points ? doc.data().points : 0,
                rage: doc.data().rage ? doc.data().rage.toFixed(2) : 0,
                date: backenddate,
                promoType: doc.data().promoType ? doc.data().promoType : null,
                promoApplied: doc.data().promoApplied
                  ? doc.data().promoApplied
                  : false,
                tokenName: doc.data().tokenName,

                // country: emaildata[0].country,
              });
            });
          } else {
            this.Spinner = false;
            this.tableData = [];
          }

          // console.log("this.tableData", this.tableData);
        });
    },

    getByToken() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      this.tableData2 = [];
      this.tbl1 = false;
      this.tbl2 = true;
      db.collection(`HTMLGamesPointsEntry`)
        .where("gameName", "==", this.name)
        .where("created", ">=", v1)
        .where("created", "<=", v2)
        .where("tokenName", "==", this.selecetedToken)
        .get()
        .then((snapshot) => {
          this.tableData2 = [];
          snapshot.forEach((doc) => {
            // let emaildata = this.userdata.filter((a) => {
            //   return a.email == doc.data().email;
            if (!this.tokens.includes(doc.data().tokenName)) {
              this.tokens.push(doc.data().tokenName);
            }
            // });
            this.Spinner = false;
            let backenddate = moment(doc.data().created.seconds * 1000).format(
              "DD-MMM-YYYY"
            );
            // if (backenddate >= v1 && backenddate <= v2) {
            this.tableData2.push({
              // Id: doc.id,
              //   name: emaildata[0].name,
              date: backenddate,
              email: doc.data().email,
              // date: doc.data().date,
              points: doc.data().points ? doc.data().points : 0,
              rage: doc.data().rage ? doc.data().rage.toFixed(2) : 0,
              promoType: doc.data().promoType ? doc.data().promoType : null,
              promoApplied: doc.data().promoApplied
                ? doc.data().promoApplied
                : false,
              tokenName: doc.data().tokenName,

              //   country: emaildata[0].country,
            });
            // }
          });
        });
    },

    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
    },

    deleteRoute(item) {
      // console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    // sendmsg(){}
  },
  created() {
    // this.getuserlist();
    this.getmessage();
    // this.sendmsg();
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}

.flex {
  display: flex;
  /* justify-content: space-between; */
}
</style>